import React from "react";
import { Typography, Button, Box } from "@mui/material";

export default function PersonnelConditionButton({ onClick }) {
  return (
    <Box textAlign="center">
      <Button
        onClick={onClick}
        variant="contained"
        sx={{
          marginTop: "30px",
          marginBottom: "30px",
          color: "white",
          fontSize: "14px",
          fontWeight: "bold",
          backgroundColor: "#28345e",
          borderRadius: "25px",
          width: { xs: "150px", sm: "180px" },
          "&:hover": {
            background: "#8bb6c6",
          },
        }}
      >
        <Typography
          sx={{
            fontSize: 14,
            marginTop: "10px",
            marginBottom: "10px",
          }}
          fontWeight="bold"
        >
          検索
        </Typography>
      </Button>
    </Box>
  );
}